import { NavLink } from "react-router-dom";
import Icon from "../../components/AppIcon";

const menu = 
[
  { label: "Dashboard", path: "/admin/dashboard", icon: "LayoutDashboard" },
  { label: "Blogs", path: "/admin/blogs", icon: "FileText" },
  { label: "Bootcamp", path: "/admin/bootcamp", icon: "Learning" },
  { label: "Courses", path: "/admin/courses", icon: "BookOpen" },
  { label: "Plans", path: "/admin/plans", icon: "CreditCard" },
  { label: "Company Questions", path: "/admin/questions/add", icon: "Plus" },
  { label: "Upload Questions", path: "/admin/questions/upload", icon: "Upload" },
  { label: "Plan Comparison", path: "/admin/plan-comparison", icon: "Table" },
  { label: "Home Page", path: "/admin/home", icon: "Home" },
  { label: "About Page", path: "/admin/about", icon: "Info" },
  { label: "Methodology Section", path: "/admin/methodology", icon: "Workflow" },
  { label: "Founder Story", path: "/admin/founder", icon: "Lightbulb" },
  { label: "Platform Features", path: "/admin/platform-features", icon: "Layers" },
  { label: "Testimonials", path: "/admin/testimonials", icon: "MessageSquare" },
  { label: "FAQs", path: "/admin/faqs", icon: "HelpCircle" },
  { label: "Stats", path: "/admin/stats", icon: "BarChart3" },
  { label: "Users", path: "/admin/users", icon: "Users" },
  { label: "Role-Manager", path: "/admin/role-manager", icon: "Users" },
   // 🔥 NEW – INTERN ASSESSMENT
  {
    label: "Intern Assessment",
    path: "/admin/intern-assessment/create",
    icon: "ClipboardCheck"
  },
  {
    label: "Intern Results",
    path: "/admin/intern-assessment/results",
    icon: "ListChecks"
  }
 
];


const AdminSidebar = () => {
  return (
    <aside className="w-64 bg-card border-r border-border p-4">
      <h2 className="text-xl font-bold mb-6">Admin Panel</h2>

      <nav className="space-y-1">
        {menu.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm
              ${isActive ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`
            }
          >
            <Icon name={item.icon} size={18} />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default AdminSidebar;
